import { useEffect } from "react";
import { withRouter } from "react-router-dom";

/** How long to keep looking for a hash target that has not rendered yet. */
const HASH_RETRY_MS = 1500;

/**
 * Scroll position on navigation: to the top for a new page, to the anchor when
 * the URL has one.
 *
 * The anchor case is why this exists. hanamaru's price breakdown links straight
 * into Unique Request articles (`.../harga-unique-request#price-jpy`). On a
 * full page load the browser looks for #price-jpy before React has rendered
 * the article, finds nothing, and stays at the top; the old app then also
 * called scrollTo(0, 0) on mount. So the link opened the article but never the
 * line it pointed at. This waits for the element, then scrolls to it; the
 * sticky header is cleared by `scroll-margin-top` in Help.scss.
 */
const ScrollManager = ({ location }) => {
  const { pathname, hash } = location;

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const id = decodeURIComponent(hash.slice(1));
    const startedAt = Date.now();
    let timer = null;

    const tryScroll = () => {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
      else if (Date.now() - startedAt < HASH_RETRY_MS) timer = window.setTimeout(tryScroll, 50);
    };
    tryScroll();

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
};

export default withRouter(ScrollManager);
